import { LoadingSpinner } from '../common/Loading';

export default function LoadingFallback() {
  return <LoadingSpinner size="lg" color="cyan" text="加载中..." />;
}
